export function getChatHistoryExportState({
  hasPerson = false,
  isConfigured = false,
  canManage = false,
  isDownloading = false
} = {}) {
  if (hasPerson || !isConfigured || !canManage) {
    return null;
  }

  return {
    disabled: Boolean(isDownloading),
    active: Boolean(isDownloading),
    buttonLabel: isDownloading ? "Downloading" : "Download"
  };
}

export function getTranscriptionHistoryExportState({
  hasPerson = false,
  isConfigured = false,
  canManage = false,
  isDownloading = false
} = {}) {
  if (hasPerson || !isConfigured || !canManage) {
    return null;
  }

  return {
    disabled: Boolean(isDownloading),
    active: Boolean(isDownloading),
    buttonLabel: isDownloading ? "Downloading" : "Download"
  };
}
